"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _arity2 = _interopRequireDefault(require("./internal/_arity")),
    _curry = _interopRequireDefault(require("./internal/_curry2")),
    _has2 = _interopRequireDefault(require("./internal/_has"));

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}

var memoizeWith = (0, _curry["default"])(function (a, b) {
  var c = {};
  return (0, _arity2["default"])(b.length, function () {
    var d = a.apply(this, arguments);
    return (0, _has2["default"])(d, c) || (c[d] = b.apply(this, arguments)), c[d];
  });
}),
    _default = memoizeWith;
exports["default"] = _default;